import axiosInstance from ".";

export const getFooter = () => {
  return axiosInstance.get("/admin/page-content?page_url=/footer");
};

export const updateFooter = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/admin/page-content/${id}`, payload);
};